var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-menu-container",style:(_vm.style),on:{"blur":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }